import { render, staticRenderFns } from "./PorAcs.vue?vue&type=template&id=511ce3d2&scoped=true"
import script from "./PorAcs.vue?vue&type=script&lang=js"
export * from "./PorAcs.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=511ce3d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ce3d2",
  null
  
)

export default component.exports